import type { PublicTemporaryMessage, Screen } from '@api-client/temporary-messages';
import { ensureLeadingSlash, matchPath, stripQueryParameters } from '@luna/router';

import { type MessageId, type ScreenToPathsMap, Screens } from './TemporaryMessagesTypes';

export const getMessageScreenForCurrentPath = (
    screens: Screen[],
    screenToPathsMap: ScreenToPathsMap,
): Screen | undefined => {
    const currentPath = stripQueryParameters(ensureLeadingSlash(window.location.hash));

    return screens.find((screen) =>
        screenToPathsMap[screen]?.some(({ path, end = true }) =>
            matchPath({ path, end }, currentPath),
        ),
    );
};

function shallDisplayMessage(
    messageId: string,
    messageScreens: Screen[],
    messagesIdsBlacklist: (string | number)[],
    screenToPathsMap: ScreenToPathsMap,
): boolean {
    if (messagesIdsBlacklist.includes(messageId)) {
        return false;
    }

    return !!getMessageScreenForCurrentPath(messageScreens, screenToPathsMap);
}

export function filterTemporaryMessagesToDisplay(
    temporaryMessages: PublicTemporaryMessage[] | undefined,
    closedMessagesIds: MessageId[],
    screenToPathsMap: ScreenToPathsMap,
): PublicTemporaryMessage[] {
    if (!temporaryMessages) {
        return [];
    }

    return temporaryMessages.filter(({ id, screens }) =>
        shallDisplayMessage(id, screens, closedMessagesIds, screenToPathsMap),
    );
}

export function getSimulatedTemporaryMessage(): PublicTemporaryMessage {
    return {
        id: 'SIMULATED_TEMPORARY_MESSAGE_ID',
        screens: Object.values(Screens),
        localizedText: {
            title: 'Temporary message - SCREEN and its url mapping need to be defined for every page',
            preview:
                'When you set vertical position of elements(top) please double-check if layout of page is not broken when temporary message preview is displayed. To make it work with temporary messages use sass <b>tmpMessageMixin.with-temporary-message</b>.',
            body: 'When you set vertical position of elements(top) please double-check if layout of page is not broken when temporary message preview is displayed. To make it work with temporary messages use sass <b>tmpMessageMixin.with-temporary-message</b>. Do not forget about the tmp messages collapsed state and different screen sizes.',
        },
        closeable: false,
        severity: 'INFO',
    };
}
